export default "__VITE_ASSET__a68189ac__"